export const languages = {
    "data": [
        {
            "id": "ff017efa-5d6e-4ffa-9054-ab0464f50c06",
            "name": "Albanian",
            "code": "SQ",
            "nativeLanguageName": "Shqiptare",
            "isoCode": "sq-AL",
            "isoFriendlyName": "Albanian (Albania)"
        },
        {
            "id": "07b39b35-683f-4456-94eb-ce4088dda411",
            "name": "Arabic",
            "code": "AR",
            "nativeLanguageName": "عربي",
            "isoCode": "ar-SA",
            "isoFriendlyName": "Arabic (Saudi Arabia)"
        },
        {
            "id": "84c3f981-3f2b-4862-a28d-5fe9e5510ac1",
            "name": "Azerbaijani",
            "code": "AZ",
            "nativeLanguageName": "Azərbaycanca",
            "isoCode": "az-AZ",
            "isoFriendlyName": "Azerbaijani (Azerbaijan)"
        },
        {
            "id": "ba4b7c8d-60b1-4686-8e91-a9dce1b1e6c1",
            "name": "Bengali",
            "code": "BN",
            "nativeLanguageName": "বাংলা",
            "isoCode": "bn-BD",
            "isoFriendlyName": "Bengali (Bangladesh)"
        },
        {
            "id": "3436f243-8564-4ac1-99c1-98cebd74a1f5",
            "name": "Bengali (India)",
            "code": "BN-IN",
            "nativeLanguageName": "বাংলা",
            "isoCode": "bn-IN",
            "isoFriendlyName": "Bengali (India)"
        },
        {
            "id": "6dae5e04-af01-443d-a056-ed04f1bbb77f",
            "name": "Bosnian (Bosnia and Herzegovina)",
            "code": "BS-BA",
            "nativeLanguageName": "Bosanski",
            "isoCode": "bs-BA",
            "isoFriendlyName": "Bosnian (Bosnia and Herzegovina)"
        },
        {
            "id": "9d2f4ca5-cef0-4ae7-9a4d-d2c8626b2746",
            "name": "Bulgarian",
            "code": "BG",
            "nativeLanguageName": "Български",
            "isoCode": "bg-BG",
            "isoFriendlyName": "Bulgarian (Bulgaria)"
        },
        {
            "id": "123829fb-7e0c-49e0-b5d2-e2d24682d92b",
            "name": "Chinese (China)",
            "code": "ZH-CN",
            "nativeLanguageName": "中文 (中国)",
            "isoCode": "zh-CN",
            "isoFriendlyName": "Chinese (China)"
        },
        {
            "id": "36c03efd-f4ae-4168-b38c-d665ac432e55",
            "name": "Chinese (Hong Kong)",
            "code": "ZH-HK",
            "nativeLanguageName": "中文 (香港)",
            "isoCode": "zh-HK",
            "isoFriendlyName": "Chinese (Hong Kong)"
        },
        {
            "id": "5d75a20d-0cf4-49b1-bae2-528fcdc12a4a",
            "name": "Chinese Simplified",
            "code": "ZH-Hans",
            "nativeLanguageName": "汉语",
            "isoCode": "zh-Hans",
            "isoFriendlyName": "Chinese (Simplified)"
        },
        {
            "id": "830f93fa-be52-4b79-b5dd-f13576708169",
            "name": "Chinese (Taiwan)",
            "code": "ZH-TW",
            "nativeLanguageName": "中文 (台灣)",
            "isoCode": "zh-TW",
            "isoFriendlyName": "Chinese (Taiwan)"
        },
        {
            "id": "82877a7d-f631-48e8-a6cc-47eb2da35b1e",
            "name": "Chinese Traditional",
            "code": "ZH-Hant",
            "nativeLanguageName": "漢語",
            "isoCode": "zh-Hant",
            "isoFriendlyName": "Chinese (Traditional)"
        },
        {
            "id": "1b682c52-d2f8-43da-adc0-eb1db1d2f0c8",
            "name": "Croatian",
            "code": "HR",
            "nativeLanguageName": "Hrvatski",
            "isoCode": "hr-HR",
            "isoFriendlyName": "Croatian (Croatia)"
        },
        {
            "id": "3d4d1f58-6a40-4b02-9dae-c51335b514b6",
            "name": "Czech",
            "code": "CS",
            "nativeLanguageName": "čeština",
            "isoCode": "cs-CZ",
            "isoFriendlyName": "Czech (Czech Republic)"
        },
        {
            "id": "27f9e3f7-d6b4-4c14-bf28-b8bb8f5e8db5",
            "name": "Danish",
            "code": "DA",
            "nativeLanguageName": "Dansk",
            "isoCode": "da-DK",
            "isoFriendlyName": "Danish (Denmark)"
        },
        {
            "id": "f6c3bcaf-5009-4eac-904a-0027e0219f9d",
            "name": "Dutch",
            "code": "NL",
            "nativeLanguageName": "Nederlands",
            "isoCode": "nl-NL",
            "isoFriendlyName": "Dutch (The Netherlands)"
        },
        {
            "id": "6b6f3f53-2483-46d3-a0a3-1c0da4a19f39",
            "name": "Dutch (Belgium)",
            "code": "NL-BE",
            "nativeLanguageName": "Nederlands (België)",
            "isoCode": "nl-BE",
            "isoFriendlyName": "Dutch (Belgium)"
        },
        {
            "id": "c9fe99e2-f9a0-4cb9-8c68-84e719954265",
            "name": "English (AU)",
            "code": "EN-AU",
            "nativeLanguageName": "English",
            "isoCode": "en-AU",
            "isoFriendlyName": "English (Australia)"
        },
        {
            "id": "47276d00-622d-47a7-b38f-a81ba92de262",
            "name": "English (Canada)",
            "code": "EN-CA",
            "nativeLanguageName": "English (Canada)",
            "isoCode": "en-CA",
            "isoFriendlyName": "English (Canada)"
        },
        {
            "id": "c931531c-2f07-47c6-b418-fb027304dedf",
            "name": "English (India)",
            "code": "EN-IN",
            "nativeLanguageName": "English (India)",
            "isoCode": "en-IN",
            "isoFriendlyName": "English (India)"
        },
        {
            "id": "223c74ab-1681-4bbc-8010-5b11eb485b5a",
            "name": "English (Ireland)",
            "code": "EN-IE",
            "nativeLanguageName": "English (Ireland)",
            "isoCode": "en-IE",
            "isoFriendlyName": "English (Ireland)"
        },
        {
            "id": "7bcf9ce0-8231-4ed1-bd5b-7c18ed0eb0c1",
            "name": "English (New Zealand)",
            "code": "EN-NZ",
            "nativeLanguageName": "English (New Zealand)",
            "isoCode": "en-NZ",
            "isoFriendlyName": "English (New Zealand)"
        },
        {
            "id": "a645bb0e-bb64-4b5c-bb93-69a698129c91",
            "name": "English (South Africa)",
            "code": "EN-ZA",
            "nativeLanguageName": "English (South Africa)",
            "isoCode": "en-ZA",
            "isoFriendlyName": "English (South Africa)"
        },
        {
            "id": "2b1583d7-d76b-45ac-b5a5-fe58d00c70ff",
            "name": "English (UK)",
            "code": "EN-UK",
            "nativeLanguageName": "English",
            "isoCode": "en-GB",
            "isoFriendlyName": "English (United Kingdom)"
        },
        {
            "id": "97f05953-cc04-4595-9860-51525b3f7712",
            "name": "English (US)",
            "code": "EN-US",
            "nativeLanguageName": "English",
            "isoCode": "en-US",
            "isoFriendlyName": "English (United States)"
        },
        {
            "id": "00940eff-be17-46cd-ab6e-96135b008ae8",
            "name": "Estonian",
            "code": "ET",
            "nativeLanguageName": "Eesti",
            "isoCode": "et-EE",
            "isoFriendlyName": "Estonian (Estonia)"
        },
        {
            "id": "02f4fefc-789d-40a0-a238-60b0b9c68190",
            "name": "Filipino",
            "code": "TL",
            "nativeLanguageName": "Filipino",
            "isoCode": "fil-PH",
            "isoFriendlyName": "Filipino (Philippines)"
        },
        {
            "id": "d7ab63b9-60bb-4822-a8d9-edf20540a323",
            "name": "Finnish",
            "code": "FI",
            "nativeLanguageName": "Suomi",
            "isoCode": "fi-FI",
            "isoFriendlyName": "Finnish (Finland)"
        },
        {
            "id": "5b607464-2893-4019-a368-9fd18e0542cb",
            "name": "French",
            "code": "FR",
            "nativeLanguageName": "Français",
            "isoCode": "fr-FR",
            "isoFriendlyName": "French (France)"
        },
        {
            "id": "d0d6ac8e-e6ee-40c0-80fb-f853d2f7f95c",
            "name": "French (Belgium)",
            "code": "FR-BE",
            "nativeLanguageName": "Français (Belgique)",
            "isoCode": "fr-BE",
            "isoFriendlyName": "French (Belgium)"
        },
        {
            "id": "58207658-c05c-4f86-9aa8-66ebceb285f3",
            "name": "French (Canada)",
            "code": "FR-CA",
            "nativeLanguageName": "Français (Canada)",
            "isoCode": "fr-CA",
            "isoFriendlyName": "French (Canada)"
        },
        {
            "id": "704bc924-4e3d-43f7-a8de-c6d1b924cd2c",
            "name": "French (Switzerland)",
            "code": "FR-CH",
            "nativeLanguageName": "Français (Suisse)",
            "isoCode": "fr-CH",
            "isoFriendlyName": "French (Switzerland)"
        },
        {
            "id": "49a0ccd1-dd20-4b05-b1a3-08202c9b2f55",
            "name": "Georgian",
            "code": "KA",
            "nativeLanguageName": "ქართული",
            "isoCode": "ka-GE",
            "isoFriendlyName": "Georgian (Georgia)"
        },
        {
            "id": "03a7b1e5-fc41-4954-954e-6e0118433019",
            "name": "German",
            "code": "DE",
            "nativeLanguageName": "Deutsch",
            "isoCode": "de-DE",
            "isoFriendlyName": "German (Germany)"
        },
        {
            "id": "717e2ce2-1b14-4939-a0d8-84a44bf865cf",
            "name": "German (Austria)",
            "code": "DE-AT",
            "nativeLanguageName": "Deutsch (Österreich)",
            "isoCode": "de-AT",
            "isoFriendlyName": "German (Austria)"
        },
        {
            "id": "f5d1da6c-f4a0-4e90-bcac-5eb595bfeb33",
            "name": "German (Switzerland)",
            "code": "DE-CH",
            "nativeLanguageName": "Deutsch (Schweiz)",
            "isoCode": "de-CH",
            "isoFriendlyName": "German (Switzerland)"
        },
        {
            "id": "0c2090c6-ed04-4989-ad0a-ce7267673c9b",
            "name": "Greek",
            "code": "EL",
            "isoCode": "el-GR",
            "isoFriendlyName": "Greek (Greece)"
        },
        {
            "id": "ecf80dd8-414f-418a-9525-375a93f20301",
            "name": "Hebrew",
            "code": "HE",
            "nativeLanguageName": "עברית",
            "isoCode": "he-IL",
            "isoFriendlyName": "Hebrew (Israel)"
        },
        {
            "id": "f999ed02-8839-424e-ac6a-2a7c62914163",
            "name": "Hindi",
            "code": "HI",
            "isoCode": "hi-IN",
            "isoFriendlyName": "Hindi (India)"
        },
        {
            "id": "ec62e3a8-1444-4d62-bb54-67a7e889cf57",
            "name": "Hungarian",
            "code": "HU",
            "nativeLanguageName": "Magyar",
            "isoCode": "hu-HU",
            "isoFriendlyName": "Hungarian (Hungary)"
        },
        {
            "id": "f835bf75-3f19-4211-8615-175339fafd06",
            "name": "Icelandic",
            "code": "IS",
            "nativeLanguageName": "íslenskur",
            "isoCode": "is-IS",
            "isoFriendlyName": "Icelandic (Iceland)"
        },
        {
            "id": "004cae2b-1f3e-41b5-a7c6-6bca731838df",
            "name": "Indonesian",
            "code": "ID",
            "nativeLanguageName": "Bahasa Indonesia",
            "isoCode": "id-ID",
            "isoFriendlyName": "Indonesian (Indonesia)"
        },
        {
            "id": "55ca6872-282e-4ec8-9e31-6fd3ff6d1843",
            "name": "Irish (Ireland)",
            "code": "GA-IE",
            "nativeLanguageName": "Gaeilge",
            "isoCode": "ga-IE",
            "isoFriendlyName": "Irish (Ireland)"
        },
        {
            "id": "5cbfcf83-cc2e-402a-b2d4-e680dd153e6c",
            "name": "Italian",
            "code": "IT",
            "nativeLanguageName": "Italiano",
            "isoCode": "it-IT",
            "isoFriendlyName": "Italian (Italy)"
        },
        {
            "id": "cfeabb3f-cea6-4bc1-a8b3-b4814535f8e3",
            "name": "Italian (Switzerland)",
            "code": "IT-CH",
            "nativeLanguageName": "Italiano (Svizzera)",
            "isoCode": "it-CH",
            "isoFriendlyName": "Italian (Switzerland)"
        },
        {
            "id": "030d7a46-d6c4-438b-9987-2f8a24370174",
            "name": "Japanese",
            "code": "JA",
            "nativeLanguageName": "日本語",
            "isoCode": "ja-JP",
            "isoFriendlyName": "Japanese (Japan)"
        },
        {
            "id": "69b57e2a-c3d9-43c5-be86-3324c20e8ea0",
            "name": "Kazakh",
            "code": "KK",
            "nativeLanguageName": "Қазақ тілі",
            "isoCode": "kk-KZ",
            "isoFriendlyName": "Kazakh (Kazakhstan)"
        },
        {
            "id": "6abbe8df-e285-4cf1-a398-a7015238f6fb",
            "name": "Korean",
            "code": "KO",
            "nativeLanguageName": "한국어",
            "isoCode": "ko-KR",
            "isoFriendlyName": "Korean (Republic of Korea)"
        },
        {
            "id": "f689f520-72d8-4825-8328-1e13a3d4b03c",
            "name": "Kyrgyz",
            "code": "KY",
            "nativeLanguageName": "Кыргызча",
            "isoCode": "ky-KG",
            "isoFriendlyName": "Kyrgyz (Kyrgyzstan)"
        },
        {
            "id": "f1734266-ab10-4de9-b407-a0b8ea5ac1a2",
            "name": "Latvian (Latvia)",
            "code": "LV-LV",
            "nativeLanguageName": "Latviešu",
            "isoCode": "lv-LV",
            "isoFriendlyName": "Latvian (Latvia)"
        },
        {
            "id": "74a5d6b3-dea3-44c8-9ce6-a740df526f26",
            "name": "Lithuanian (Lithuania)",
            "code": "LT-LT",
            "nativeLanguageName": "Lietuvių",
            "isoCode": "lt-LT",
            "isoFriendlyName": "Lithuanian (Lithuania)"
        },
        {
            "id": "75fe81b0-dfbb-44bb-9842-6ca81e262324",
            "name": "Luxembourgish (Luxembourg)",
            "code": "LB-LU",
            "nativeLanguageName": "Lëtzebuergesch",
            "isoCode": "lb-LU",
            "isoFriendlyName": "Luxembourgish (Luxembourg)"
        },
        {
            "id": "67b1d9ec-63f0-472d-92a7-26f33940bf4b",
            "name": "Macedonian",
            "code": "MK",
            "nativeLanguageName": "Македонски",
            "isoCode": "mk-MK",
            "isoFriendlyName": "Macedonian (North Macedonia)"
        },
        {
            "id": "6bdba261-58eb-4dd4-a7fe-f5849b92394c",
            "name": "Malay",
            "code": "MS",
            "nativeLanguageName": "Melayu",
            "isoCode": "ms-MY",
            "isoFriendlyName": "Malay (Malaysia)"
        },
        {
            "id": "bb23a9c4-af44-4df0-88af-96dd853dd312",
            "name": "Maltese (Malta)",
            "code": "MT-MT",
            "nativeLanguageName": "Malti",
            "isoCode": "mt-MT",
            "isoFriendlyName": "Maltese (Malta)"
        },
        {
            "id": "3a2f48b4-dfd1-4856-a1b7-bb3cd834a3f9",
            "name": "Norwegian",
            "code": "NO",
            "nativeLanguageName": "Norsk",
            "isoCode": "no-NO",
            "isoFriendlyName": "Norwegian (Norway)"
        },
        {
            "id": "24f12aab-297a-486d-a9a1-5cb09d9dc4af",
            "name": "Polish",
            "code": "PL",
            "nativeLanguageName": "Polski",
            "isoCode": "pl-PL",
            "isoFriendlyName": "Polish (Poland)"
        },
        {
            "id": "3e90cf09-59f8-4bbd-9ac6-c1bc2e05c815",
            "name": "Portuguese",
            "code": "PT",
            "nativeLanguageName": "Português",
            "isoCode": "pt-PT",
            "isoFriendlyName": "Portuguese (Portugal)"
        },
        {
            "id": "d3a5e3f9-5e02-4e5e-8c39-b7c2ae49ef4a",
            "name": "Portuguese (Brazilian)",
            "code": "PT-BR",
            "nativeLanguageName": "Português (Brasil)",
            "isoCode": "pt-BR",
            "isoFriendlyName": "Portuguese (Brazil)"
        },
        {
            "id": "5f3151da-5b02-4fc7-94c5-ae8ce38eacdb",
            "name": "Romanian",
            "code": "RO",
            "nativeLanguageName": "Romanesc",
            "isoCode": "ro-RO",
            "isoFriendlyName": "Romanian (Romania)"
        },
        {
            "id": "75a28940-11a0-4e10-9f44-2647d66b6142",
            "name": "Russian",
            "code": "RU",
            "nativeLanguageName": "Русский",
            "isoCode": "ru-RU",
            "isoFriendlyName": "Russian (Russia)"
        },
        {
            "id": "dc165b92-fc62-468b-9d4f-d18c3306517c",
            "name": "Serbian (Bosnia and Herzegovina)",
            "code": "SR-BA",
            "nativeLanguageName": "Српски",
            "isoCode": "sr-BA",
            "isoFriendlyName": "Serbian (Bosnia and Herzegovina)"
        },
        {
            "id": "59d7761b-c343-43a5-bc74-5a4aef99a04b",
            "name": "Serbian (Serbia)",
            "code": "SR-RS",
            "nativeLanguageName": "Српски",
            "isoCode": "sr-RS",
            "isoFriendlyName": "Serbian (Serbia)"
        },
        {
            "id": "5062569c-a15d-4dcb-b8d1-6cbe5c2c372f",
            "name": "Slovak",
            "code": "SK",
            "nativeLanguageName": "Slovenčina",
            "isoCode": "sk-SK",
            "isoFriendlyName": "Slovak (Slovakia)"
        },
        {
            "id": "19437b52-18cd-4537-9e26-674f4c386f98",
            "name": "Slovenian",
            "code": "SL",
            "nativeLanguageName": "Slovenski",
            "isoCode": "sl-SI",
            "isoFriendlyName": "Slovenian (Slovenia)"
        },
        {
            "id": "9a42c3a2-71c1-47e9-b368-a1d42dd3b405",
            "name": "Spanish",
            "code": "ES",
            "nativeLanguageName": "Español",
            "isoCode": "es-ES",
            "isoFriendlyName": "Spanish (Spain)"
        },
        {
            "id": "75df94aa-ff1c-4f67-a5e0-bc3a5db76cd2",
            "name": "Spanish (Argentina)",
            "code": "ES-AR",
            "nativeLanguageName": "Español (Argentina)",
            "isoCode": "es-AR",
            "isoFriendlyName": "Spanish (Argentina)"
        },
        {
            "id": "dadc532c-ae19-4f77-819d-51b5863cfbd4",
            "name": "Spanish (Chile)",
            "code": "ES-CL",
            "nativeLanguageName": "Español (Chile)",
            "isoCode": "es-CL",
            "isoFriendlyName": "Spanish (Chile)"
        },
        {
            "id": "31f8abc8-4368-4193-b978-d1af6ffeacbb",
            "name": "Spanish (Colombia)",
            "code": "ES-CO",
            "nativeLanguageName": "Español (Colombia)",
            "isoCode": "es-CO",
            "isoFriendlyName": "Spanish (Colombia)"
        },
        {
            "id": "7f1e56ba-09c9-4fbb-91a3-8c6273e5f3f5",
            "name": "Spanish (Latin American)",
            "code": "ES-LA",
            "nativeLanguageName": "Español (Latinoamérica)",
            "isoCode": "es-419",
            "isoFriendlyName": "Spanish (Latin America)"
        },
        {
            "id": "7667bf63-9ae5-449e-8a19-ed097bcfd091",
            "name": "Spanish (Mexico)",
            "code": "ES-MX",
            "nativeLanguageName": "Español (México)",
            "isoCode": "es-MX",
            "isoFriendlyName": "Spanish (Mexico)"
        },
        {
            "id": "61dc49bf-fd55-427f-a903-47867ab70ada",
            "name": "Spanish (United States)",
            "code": "ES-US",
            "nativeLanguageName": "Español (Estados Unidos)",
            "isoCode": "es-US",
            "isoFriendlyName": "Spanish (United States)"
        },
        {
            "id": "cd57b96f-4a04-4155-ae2e-91e6eec72095",
            "name": "Swedish",
            "code": "SV",
            "nativeLanguageName": "Svenska",
            "isoCode": "sv-SE",
            "isoFriendlyName": "Swedish (Sweden)"
        },
        {
            "id": "67423024-56da-4202-b66c-6967ef1733ea",
            "name": "Tagalog",
            "code": "TGL",
            "nativeLanguageName": "Tagalog",
            "isoCode": "tl-PH",
            "isoFriendlyName": "Tagalog (Philippines)"
        },
        {
            "id": "4a225d9c-95cd-4f9e-812a-559a81743b8c",
            "name": "Tajik",
            "code": "TG",
            "nativeLanguageName": "Тоҷикӣ",
            "isoCode": "tg-TJ",
            "isoFriendlyName": "Tajik (Tajikistan)"
        },
        {
            "id": "56351414-7294-427e-9936-d1e468719b2f",
            "name": "Tamil (India)",
            "code": "TA-IN",
            "nativeLanguageName": "தமிழ்",
            "isoCode": "ta-IN",
            "isoFriendlyName": "Tamil (India)"
        },
        {
            "id": "9672978c-9df0-48d0-9029-32d5fb0a64da",
            "name": "Tamil (Sri Lanka)",
            "code": "TA-LK",
            "nativeLanguageName": "தமிழ் (இலங்கை)",
            "isoCode": "ta-LK",
            "isoFriendlyName": "Tamil (Sri Lanka)"
        },
        {
            "id": "9d65fae9-277f-4208-b804-8f3d822cbaa3",
            "name": "Thai",
            "code": "TH",
            "nativeLanguageName": "ภาษาไทย",
            "isoCode": "th-TH",
            "isoFriendlyName": "Thai (Thailand)"
        },
        {
            "id": "79276617-3e2b-409d-b2d1-52eb0f4a6ec6",
            "name": "Turkish",
            "code": "TR",
            "nativeLanguageName": "Türkçe",
            "isoCode": "tr-TR",
            "isoFriendlyName": "Turkish (Turkey)"
        },
        {
            "id": "74e8860a-f38a-4c18-9eac-e272b173fe29",
            "name": "Turkmen",
            "code": "TK",
            "nativeLanguageName": "Türkmençe",
            "isoCode": "tk-TM",
            "isoFriendlyName": "Turkmen (Turkmenistan)"
        },
        {
            "id": "a7e82cc3-fb2e-488f-8b75-6d0e2b9c94a3",
            "name": "Ukrainian",
            "code": "UK",
            "nativeLanguageName": "Українська",
            "isoCode": "uk-UA",
            "isoFriendlyName": "Ukrainian (Ukraine)"
        },
        {
            "id": "5ef30467-d352-45e8-a26e-82271f24dfdd",
            "name": "Urdu",
            "code": "UR",
            "nativeLanguageName": "اردو",
            "isoCode": "ur-PK",
            "isoFriendlyName": "Urdu (Pakistan)"
        },
        {
            "id": "10e7b8c5-6d59-4f6d-b1be-f310eef5ca53",
            "name": "Uzbek",
            "code": "UZ",
            "nativeLanguageName": "Oʻzbekcha",
            "isoCode": "uz-UZ",
            "isoFriendlyName": "Uzbek (Uzbekistan)"
        },
        {
            "id": "43148ea7-ee75-4ee2-a675-1001e3b654f8",
            "name": "Vietnamese",
            "code": "VI",
            "nativeLanguageName": "Tiếng Việt Nam",
            "isoCode": "vi-VN",
            "isoFriendlyName": "Vietnamese (Vietnam)"
        },
        {
            "id": "dc884d05-257e-4afe-bbc3-79e751c958e2",
            "name": "Welsh (United Kingdom)",
            "code": "CY-GB",
            "nativeLanguageName": "Cymraeg",
            "isoCode": "cy-GB",
            "isoFriendlyName": "Welsh (United Kingdom)"
        }
    ],
    "status": "SUCCESS",
    "message": "Resource retrieved",
    "validationMessages": []
}